export interface DashboardItemConfig {
  step: number
  title: string
  subtitle: string
  path: string
}

export const dashboardItems: DashboardItemConfig[] = [
  {
    step: 1,
    title: 'ALSFRS-R',
    subtitle: 'Step #1',
    path: '1',
  },
  {
    step: 2,
    title: 'ALSSQ',
    subtitle: 'Step #2',
    path: '2',
  },
  {
    step: 3,
    title: 'Mindset',
    subtitle: 'Step #3',
    path: '3',
  },
  {
    step: 4,
    title: 'Stool and Urine',
    subtitle: 'Step #4',
    path: '4',
  },
  {
    step: 5,
    title: 'Vital Statistics',
    subtitle: 'Step #5',
    path: '5',
  },
  {
    step: 6,
    title: 'Journal - Clinical Observations',
    subtitle: 'Step #6',
    path: '6',
  },
  {
    step: 7,
    title: 'Diet',
    subtitle: 'Step #7',
    path: '7',
  },
  {
    step: 8,
    title: 'Supplements',
    subtitle: 'Step #8',
    path: '8',
  },
  {
    step: 9,
    title: 'Medications',
    subtitle: 'Step #9',
    path: '9',
  },
  {
    step: 10,
    title: 'Physical Strategies',
    subtitle: 'Step #10',
    path: '10',
  },
  {
    step: 11,
    title: 'Mind Strategies',
    subtitle: 'Step #11',
    path: '11',
  },
  {
    step: 12,
    title: 'Core Education & Steps',
    subtitle: 'Step #12',
    path: '12',
  },
  {
    step: 13,
    title: 'Support Team',
    subtitle: 'Step #13',
    path: '13',
  },
]
